import React, { useEffect, useState } from "react";
import { useSearchParams } from 'react-router-dom';
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import Select from "react-select";
import { Button } from "components/ui/button";
import { Input } from "components/ui/input";
import { Alert, AlertDescription } from "components/ui/alert";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "components/ui/dialog";

import {
    SG_COPY_SURVEY_STRUCTURE,
    SG_SURVEY_STRUCTURE_SELECT,
    GET_AM_ORGANIZATION
} from "constants/actions";

const QUERY_PARAMS = "organization"

const CopyCategory = ({ trigger, setOrganizationId }) => {
    const dispatch = useDispatch();
    const [pristine, setPristine] = useState(true)
    const [createCategory, setCreateCategory] = useState(false)

    const [formErrors, setFormErrors] = useState([]);
    const [categoryName, setCategoryName] = useState('');
    const [categorySelected, setCategorySelected] = useState('');
    const [categoryList, setCategoryList] = useState([]);
    const [organizationSelect, setOrganizationSelect] = useState([])
    const [organizationSelected, setOrganizationSelected] = useState([])

    const [extOrganizationList, setExtOrganizationList] = useState([])

    const [searchParams, setSearchParams] = useSearchParams();
    const newQueryParameters = new URLSearchParams();


    const { get_survey_structure,
        get_organization_select } = useSelector(
            (state) => ({
                get_survey_structure: state.surveystructure.survey_struture_select,
                get_organization_select: state.organizations.organization_select,
            }),
            shallowEqual
        );

    useEffect(() => {
        if (get_survey_structure) {
            setCategoryList(get_survey_structure)
        }
    }, [get_survey_structure]);

    useEffect(() => {
        dispatch({
            type: SG_SURVEY_STRUCTURE_SELECT,
        });
    }, [dispatch]);

    useEffect(() => {
        setOrganizationSelect(
            get_organization_select.filter(or => !extOrganizationList.includes(or.id)))

    }, [get_organization_select, extOrganizationList]);


    useEffect(() => {
        setExtOrganizationList(get_survey_structure.map(ss => ss.organization))
    }, [get_survey_structure]);

    const onSubmit = () => {
        if (formErrors.length > 0) {
            setPristine(false)
            return
        }
        setPristine(true)
        dispatch({
            type: SG_COPY_SURVEY_STRUCTURE,
            payload: {
                organization_id: organizationSelected?.id,
                name: categoryName,
                ext_survey_structure_id: categorySelected.id
            },
        });
        dispatch({
            type: GET_AM_ORGANIZATION,
            payload: organizationSelected
        });
        setCreateCategory(false)
        setOrganizationId(organizationSelected?.id)
        newQueryParameters.set(QUERY_PARAMS, organizationSelected.id)
        setSearchParams(newQueryParameters)
    }

    useEffect(() => {
        const ErrorList = []

        if (!categoryName) {
            ErrorList.push("Enter a Name")
        }
        if (!organizationSelected?.id) {
            ErrorList.push("No Organization Found")
        }

        if (!categorySelected?.id) {
            ErrorList.push("Select from List")
        }

        setFormErrors(ErrorList)
    }, [categoryName, categorySelected, pristine, organizationSelected]);

    function ChangedOrganization(e) {
        setOrganizationSelected(e)
      }

    return (
        <Dialog open={createCategory} onOpenChange={setCreateCategory}>
            <DialogTrigger asChild>
                {trigger}
            </DialogTrigger>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Copy a category</DialogTitle>
                </DialogHeader>
                <div className="flex">
                    <div className="w-full px-8 py-8">
                        {formErrors.length > 0 && !pristine && (
                            <Alert variant="destructive">
                                <AlertDescription>
                                    <ul className="list-disc pl-4">
                                        {formErrors.map((err, idx) => (<li key={idx}>{err}</li>))}
                                    </ul>
                                </AlertDescription>
                            </Alert>
                        )}
                        <div className="mt-5 w-full">
                            <div className="mb-2 font-bold">Copy From This One</div>
                            <Select
                                name="survey_preference"
                                options={categoryList}
                                onChange={setCategorySelected}
                                getOptionLabel={(option) => `${option.organization_name} - ${option.name}`}
                                getOptionValue={(option) => `${option.id}`}
                                value={categorySelected}
                                menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                menuPosition="fixed"
                                menuPlacement="auto"
                                maxMenuHeight={440}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    menu: (base) => ({ ...base, zIndex: 9999 }),
                                }}
                            />
                        </div>
                        <div className="mt-5 w-full">
                            <div className="mb-2 font-bold">Target Organization</div>
                            <Select
                                name="survey_preference"
                                options={organizationSelect}
                                onChange={ChangedOrganization}
                                getOptionLabel={(option) => `${option.name}`}
                                getOptionValue={(option) => `${option.id}`}
                                value={organizationSelected}
                                menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                menuPosition="fixed"
                                menuPlacement="auto"
                                maxMenuHeight={440}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    menu: (base) => ({ ...base, zIndex: 9999 }),
                                }}
                            />
                        </div>
                        <div className="mt-5 w-full">
                            <div className="mb-2 font-bold">Category Name</div>
                            <Input
                                placeholder='Category Name'
                                name="name"
                                value={categoryName}
                                onChange={(v) => setCategoryName(v.target.value)}
                            />
                        </div>
                        <Button className="mt-6 w-[200px]" disabled={formErrors.length > 0 && !pristine} onClick={onSubmit}>
                            Create
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    )
}

export default CopyCategory
